import { render, staticRenderFns } from "./material-movement.vue?vue&type=template&id=50ad689a&"
import script from "./material-movement.vue?vue&type=script&lang=js&"
export * from "./material-movement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports